export default __webpack_public_path__ + "static/946-2b4a92448b211853120486663a91ffe5.gif";